module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beforeTxt),
      expression: "beforeTxt"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "人类语言"
    },
    domProps: {
      "value": (_vm.beforeTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beforeTxt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('div', {
    staticStyle: {
      "border": "0",
      "width": "30%",
      "display": "inline-block",
      "line-height": "38px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replaceTxt),
      expression: "replaceTxt"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "非人语"
    },
    domProps: {
      "value": (_vm.replaceTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replaceTxt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-button', {
    on: {
      "click": function($event) {
        _vm.convertGossip()
      }
    }
  }, [_c('span', [_vm._v("流言蜚语\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": function($event) {
        _vm.convertMan()
      }
    }
  }, [_c('span', [_vm._v("人言可畏\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afterTxt),
      expression: "afterTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "非人类语言"
    },
    domProps: {
      "value": (_vm.afterTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.afterTxt = $event.target.value
      }
    }
  })]), _vm._v("\n    参考项目：https://github.com/miao-lang/miao-lang\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-066b543d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/gossip.vue
// module id = 578
// module chunks = 2